(() => {
'use strict';
function update(scope) {
const id = scope.querySelector('[data-variant-select]')?.value;
const plan = scope.querySelector('[name="selling_plan"]')?.value;
scope.querySelectorAll('[data-cz-history-variant]').forEach(node => {
node.hidden = node.dataset.czHistoryVariant !== id || Boolean(plan);
const reference = node.querySelector('[data-cz-reference-until]');
if (reference && Number(reference.dataset.czReferenceUntil) <= Date.now() / 1000) reference.remove();
});
}
document.querySelectorAll('[data-product]').forEach(update);
document.addEventListener('change', event => {
if (event.target.matches('[data-variant-select], [name="selling_plan"]')) {
const scope = event.target.closest('[data-product]');
if (scope) update(scope);
}
});
setInterval(() => document.querySelectorAll('[data-product]').forEach(update), 60000);
})();
